(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cm-banner-products"] && !Shopify.designMode) return;
  try {
    class CMBannerProducts extends HTMLElement {
    connectedCallback(){
      this.slides=[...this.querySelectorAll('[data-product-slide]')];if(this.slides.length<2)return;
      this.index=0;this.visible=false;this.hovered=false;this.focused=false;this.reduced=matchMedia('(prefers-reduced-motion: reduce)');
      this.paused=this.dataset.autoplay!=='true'||this.reduced.matches||document.body.dataset.cmMotion!=='true';
      this.delay=Math.max(4000,Number(this.dataset.interval)||6000);this.controller=new AbortController();const signal=this.controller.signal;
      this.toggle=this.querySelector('[data-products-toggle]');this.querySelector('.cm-picks__controls').hidden=false;this.sync();
      this.querySelector('[data-products-prev]').addEventListener('click',()=>this.show(this.index-1,true),{signal});
      this.querySelector('[data-products-next]').addEventListener('click',()=>this.show(this.index+1,true),{signal});
      this.toggle.addEventListener('click',()=>{this.paused=!this.paused;this.sync();this.schedule();},{signal});
      this.addEventListener('pointerenter',e=>{if(e.pointerType!=='touch'){this.hovered=true;this.schedule();}},{signal});
      this.addEventListener('pointerleave',()=>{this.hovered=false;this.schedule();},{signal});
      this.addEventListener('focusin',()=>{this.focused=true;this.schedule();},{signal});
      this.addEventListener('focusout',()=>queueMicrotask(()=>{this.focused=this.contains(document.activeElement);this.schedule();}),{signal});
      this.reduced.addEventListener('change',()=>{if(this.reduced.matches)this.paused=true;this.sync();this.schedule();},{signal});
      document.addEventListener('visibilitychange',()=>this.schedule(),{signal});
      this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.schedule();});this.observer.observe(this);
    }
    sync(){this.toggle.textContent=this.paused?this.toggle.dataset.play:this.toggle.dataset.pause;}
    schedule(){clearTimeout(this.timer);if(this.isConnected&&!this.paused&&this.visible&&!this.hovered&&!this.focused&&!document.hidden)this.timer=setTimeout(()=>{this.show(this.index+1);},this.delay);}
    show(index,manual=false){
      this.index=(index+this.slides.length)%this.slides.length;
      this.slides.forEach((slide,i)=>{const active=i===this.index;slide.classList.toggle('is-current',active);slide.inert=!active;if(active)slide.removeAttribute('aria-hidden');else slide.setAttribute('aria-hidden','true');});
      this.querySelector('[data-products-current]').textContent=String(this.index+1);
      if(manual)this.querySelector('[data-products-status]').textContent=this.slides[this.index].querySelector('h2').textContent;
      this.schedule();
    }
    disconnectedCallback(){clearTimeout(this.timer);this.controller?.abort();this.observer?.disconnect();}
  }
  if(!customElements.get('cm-banner-products'))customElements.define('cm-banner-products',CMBannerProducts);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cm-card"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('cm-shop-card'))customElements.define('cm-shop-card',class extends HTMLElement{
 connectedCallback(){this.onChange=()=>{const s=this.querySelector('[data-card-variant]');if(!s)return;this.querySelector('input[name="id"]').value=s.value;this.querySelector('input[name="quantity"]').value=s.selectedOptions[0].dataset.min;this.querySelector('[data-card-price]').textContent=s.selectedOptions[0].dataset.price;};this.addEventListener('change',this.onChange);}
 disconnectedCallback(){this.removeEventListener('change',this.onChange);}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cm-drip-offer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cm-drip-offer')) {
    customElements.define('cm-drip-offer', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.frame = requestAnimationFrame(() => {
          const form = this.closest('form');
          const input = form?.querySelector('input[name="quantity"]');
          if (!form || !input) return;
          const component = form.closest('product-form-component');
          if (component && !component.dataset.dripOfferInitialized) {
            component.dataset.dripOfferInitialized = 'true';
            const minimum = Number(input.min) || 1;
            const step = Number(input.step) || 1;
            const initial = minimum + Math.ceil(Math.max(0, 2 - minimum) / step) * step;
            if (!input.max || initial <= Number(input.max)) input.value = String(initial);
            const selector = input.closest('quantity-selector-component');
            if (selector && !input.disabled) {
              selector.serverDisabledMinus = false;
              selector.updateButtonStates?.();
            }
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
          const update = () => {
            const free = Math.floor(Math.max(0, Number(input.value) || 0) / 2);
            this.querySelector('[data-offer-status]').textContent = free ? this.dataset.qualified.replace('COUNT', String(free)) : this.dataset.remaining;
          };
          form.addEventListener('input', update, { signal: this.controller.signal });
          form.addEventListener('change', update, { signal: this.controller.signal });
          form.addEventListener('quantity-selector:update', update, { signal: this.controller.signal });
          update();
        });
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.controller?.abort();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cm-mobile-menu"] && !Shopify.designMode) return;
  try {
    (() => {
    const timers = new WeakMap();
    function select(event) {
      if (!window.matchMedia('(max-width: 749px)').matches || !(event.target instanceof Element)) return;
      const item = event.target.closest('.cm-store header-drawer .menu-drawer__menu-item');
      if (!item || (event.type === 'pointerdown' && event.button !== 0)) return;
      if (item.classList.contains('cm-menu-selected')) return;
      clearTimeout(timers.get(item));
      item.classList.add('cm-menu-selected');
      timers.set(item, setTimeout(() => item.classList.remove('cm-menu-selected'), 520));
    }
    document.addEventListener('pointerdown', select, { passive: true });
    document.addEventListener('click', select);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cm-motion"] && !Shopify.designMode) return;
  try {
    (() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  let observer;
  let stories=[];
  let hero;
  let ticking=false;
  const enabled=()=>document.body.dataset.cmMotion==='true'&&!reduced.matches;
  function frame(){
    ticking=false;
    if(!enabled()) return;
    if(hero){const rect=hero.getBoundingClientRect();if(rect.bottom>0){const media=hero.querySelector('[data-cm-parallax]');if(media)media.style.transform=`translateY(${Math.min(110,Math.max(0,-rect.top)*.17)}px)`;}}
    for(const story of stories){
      const rect=story.getBoundingClientRect();
      const sticky=story.querySelector('.cm-story__sticky');
      const stickyTop=parseFloat(getComputedStyle(sticky).top)||0;
      const progress=Math.max(0,Math.min(1,(stickyTop-rect.top)/Math.max(1,rect.height-sticky.offsetHeight)));
      const chapters=story.querySelectorAll('[data-cm-story-chapter]');
      const index=Math.min(chapters.length-1,Math.floor(progress*chapters.length));
      if(story.dataset.chapter!==String(index)){
        story.dataset.chapter=String(index);
        for(const selector of ['[data-cm-story-chapter]','[data-cm-story-image]','[data-cm-story-step]'])story.querySelectorAll(selector).forEach((e,i)=>e.classList.toggle('is-active',i===index));
      }
      const bar=story.querySelector('[data-cm-story-progress]');if(bar)bar.style.strokeDashoffset=String(100-progress*100);
      if(document.body.classList.contains('page-index')){
        const images=story.querySelectorAll('[data-cm-story-image]');
        images.forEach((image,i)=>{
          const x=Math.max(0,Math.min(1,(progress*images.length-i+.24)/.48));
          image.style.opacity=String(i===0?1:x*x*(3-2*x));
        });
      }
    }
  }
  function update(){if(!ticking){ticking=true;requestAnimationFrame(frame);}}
  function setup(){
    observer?.disconnect();
    hero=document.querySelector('[data-cm-hero]');stories=[...document.querySelectorAll('[data-cm-story]')];
    stories.forEach(s=>s.classList.toggle('cm-motion-ready',enabled()));
    if(!enabled())stories.forEach(s=>s.querySelectorAll('[data-cm-story-image]').forEach(image=>image.style.removeProperty('opacity')));
    if(enabled()&&'IntersectionObserver' in window){
      observer=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-visible');observer.unobserve(entry.target);}});},{threshold:.08,root:window.matchMedia('(min-width: 990px)').matches?document.querySelector('.page-wrapper'):null});
      document.querySelectorAll('[data-cm-reveal]').forEach(el=>{el.classList.add('cm-reveal-ready');observer.observe(el);});
    }else document.querySelectorAll('[data-cm-reveal]').forEach(el=>el.classList.add('is-visible'));
    if(hero){
      const video=hero.querySelector('video');const toggle=hero.querySelector('[data-cm-video-toggle]');
      if(video&&toggle){
        const sync=()=>{toggle.textContent=video.paused?toggle.dataset.playLabel:toggle.dataset.pauseLabel;toggle.setAttribute('aria-pressed',String(!video.paused));};
        if(!toggle.dataset.bound){toggle.dataset.bound='true';toggle.addEventListener('click',()=>video.paused?video.play().catch(sync):video.pause());video.addEventListener('play',sync);video.addEventListener('pause',sync);}
        if(enabled()){video.play().catch(sync);}else{video.pause();}sync();
      }
      if(!enabled()){const media=hero.querySelector('[data-cm-parallax]');if(media)media.style.transform='none';}
    }
    update();
  }
  document.addEventListener('shopify:section:load',setup);
  document.addEventListener('scroll',update,{passive:true,capture:true});window.addEventListener('resize',update,{passive:true});reduced.addEventListener('change',setup);window.matchMedia('(min-width: 990px)').addEventListener('change',setup);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup,{once:true});else setup();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cm-section-fades"] && !Shopify.designMode) return;
  try {
    (() => {
  const reduced=matchMedia('(prefers-reduced-motion: reduce)');
  let scenes=[],pending=false;
  const clamp=n=>Math.max(0,Math.min(1,n));
  const smooth=n=>{const x=clamp(n);return x*x*(3-2*x);};
  function paint(){
    pending=false;
    const active=document.body.dataset.cmMotion==='true'&&!reduced.matches;
    const header=document.querySelector('header-component')?.getBoundingClientRect().height||80;
    const height=innerHeight;
    for(const scene of scenes){
      const rect=scene.getBoundingClientRect();
      if(active&&(rect.bottom<0||rect.top>height))continue;
      const entering=smooth((height-rect.top)/(height*.6));
      const leaving=smooth((rect.bottom-header)/(height*.48));
      const visibility=active?Math.min(entering,leaving):1;
      scene.style.setProperty('--cm-scene-opacity',String(.3+.7*visibility));
      scene.style.setProperty('--cm-scene-shift',`${active?(1-entering)*18-(1-leaving)*12:0}px`);
    }
  }
  function update(){if(!pending){pending=true;requestAnimationFrame(paint);}}
  function setup(){scenes=[...document.querySelectorAll('.page-index .cm-story__sticky,.page-index .cm-editorial__image')];update();}
  document.addEventListener('scroll',update,{capture:true,passive:true});
  window.addEventListener('resize',update,{passive:true});
  reduced.addEventListener('change',update);
  document.addEventListener('shopify:section:load',setup);
  document.addEventListener('shopify:section:unload',setup);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup,{once:true});else setup();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cm-unroll-menu"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('cm-unroll-menu')){
 customElements.define('cm-unroll-menu',class extends HTMLElement{
  connectedCallback(){
   this.abort=new AbortController();const signal=this.abort.signal;
   this.dialog=this.querySelector('dialog');this.toggle=this.querySelector('.cm-unroll__toggle');this.closeButton=this.querySelector('.cm-unroll__close');this.header=this.closest('header-component');
   if(!this.dialog.showModal)return;
   this.toggle.hidden=false;this.header?.classList.add('cm-unroll-ready');
   this.toggle.addEventListener('click',()=>this.open(),{signal});
   window.addEventListener('resize',()=>{if(!this.dialog.open)return;document.documentElement.classList.remove('cm-navigation-open');this.alignBar();document.documentElement.classList.add('cm-navigation-open');},{signal});
   this.closeButton.addEventListener('click',()=>this.close(),{signal});
   this.dialog.addEventListener('cancel',e=>{e.preventDefault();this.close();},{signal});
   this.dialog.addEventListener('keydown',e=>{
    if(e.key!=='Tab')return;
    const targets=[...this.dialog.querySelectorAll('a[href],button:not([disabled])')].filter(el=>el.getClientRects().length&&!el.closest('[hidden]'));
    const first=targets[0],last=targets[targets.length-1];
    if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}
    else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}
   },{signal});
   this.dialog.addEventListener('close',()=>{document.documentElement.classList.remove('cm-navigation-open');this.toggle.setAttribute('aria-expanded','false');},{signal});
   this.dialog.addEventListener('click',e=>{
    const expand=e.target.closest('.cm-unroll__expand');
    if(expand){const open=expand.getAttribute('aria-expanded')==='true';expand.setAttribute('aria-expanded',String(!open));this.querySelector(`[id="${expand.getAttribute('aria-controls')}"]`).hidden=open;return;}
    if(e.target.closest('a'))this.finish(false);
   },{signal});
   document.addEventListener('shopify:section:unload',e=>{if(e.target.contains(this))this.finish(false);},{signal});
  }
  alignBar(){
   const box=this.toggle.getBoundingClientRect();
   const logo=this.header?.querySelector('.header-logo')?.getBoundingClientRect();
   const values={'close-left':box.left,'close-top':box.top,'close-width':box.width,'close-height':box.height,'bar-height':Math.max(box.bottom+12,this.header?.getBoundingClientRect().bottom||0)};
   if(logo)Object.assign(values,{'logo-left':logo.left,'logo-top':logo.top,'logo-width':logo.width,'logo-height':logo.height});
   Object.entries(values).forEach(([key,value])=>this.dialog.style.setProperty(`--cm-nav-${key}`,`${value}px`));
  }
  open(){
   clearTimeout(this.timer);if(this.dialog.open)return;
   this.alignBar();this.dialog.showModal();document.documentElement.classList.add('cm-navigation-open');this.toggle.setAttribute('aria-expanded','true');
   this.frame=requestAnimationFrame(()=>{this.frame=requestAnimationFrame(()=>this.dialog.classList.add('is-open'));});
  }
  close(){
   cancelAnimationFrame(this.frame);this.dialog.classList.remove('is-open');this.toggle.setAttribute('aria-expanded','false');
   clearTimeout(this.timer);this.timer=setTimeout(()=>this.finish(true),matchMedia('(prefers-reduced-motion:reduce)').matches?0:850);
  }
  finish(focus){clearTimeout(this.timer);cancelAnimationFrame(this.frame);this.dialog.classList.remove('is-open');this.dialog.close();document.documentElement.classList.remove('cm-navigation-open');this.toggle.setAttribute('aria-expanded','false');if(focus)this.toggle.focus({preventScroll:true});}
  disconnectedCallback(){this.abort?.abort();if(this.dialog)this.finish(false);this.header?.classList.remove('cm-unroll-ready');}
 });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["custom-variant-description"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('cm-course-details')){
  customElements.define('cm-course-details',class extends HTMLElement{
    connectedCallback(){
      this.scope=this.closest('.shopify-section')||document;
      this.sync=()=>{
        const selected=this.scope.querySelector('variant-picker input[data-fieldset-index="0"]:checked')||this.scope.querySelector('variant-picker select');
        if(!selected)return;
        this.querySelectorAll('[data-level]').forEach(item=>{item.hidden=item.dataset.level!==selected.value.trim();});
      };
      this.onChange=event=>{if(event.target.closest('variant-picker'))this.sync();};
      this.scope.addEventListener('change',this.onChange);
      this.sync();
    }
    disconnectedCallback(){this.scope?.removeEventListener('change',this.onChange);}
  });
}
  } catch(e) { console.error(e); }
})();

})();
